import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Adjustment } from '../../models/statements.models';
import { map } from 'rxjs/operators';
import { StatementsFacade } from '@app/modules/statements/services/statements.facade';

@Component({
  selector: 'sbnb-statements-adjustments-table',
  templateUrl: './statements-adjustments-table.component.html',
  styles: [
    `
      @media (min-width: 768px) {
        :host ::ng-deep .mat-drawer {
          top: 4px !important;
          bottom: 4px !important;
          right: 4px !important;
          border-radius: 8px !important;
        }
      }
      ::ng-deep.mat-drawer-backdrop {
        position: fixed !important;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    `,
  ],
})
export class StatementsAdjustmentsTableComponent {
  @ViewChild('previewPane') previewPane!: MatSidenav;
  @Input() previewedAdjustment: Adjustment | null;
  @Output() pageChanged = new EventEmitter<number>();
  @Output() adjustmentSelected = new EventEmitter<string>();
  @Output() adjustmentApplied = new EventEmitter<void>();

  public state$ = this.statementsFacade.adjustmentsState$;

  public displayedColumns: string[] = ['date', 'property', 'code', 'guest', 'reason', 'amount', 'actions'];

  public paginatedData$ = this.state$.pipe(map((state) => state.data));

  public pagination$ = this.state$.pipe(
    map((state) => ({
      currentPage: state.meta?.current_page,
      totalPages: state.meta?.last_page,
      pageSize: state.meta?.per_page,
      totalItems: state.meta?.total,
    }))
  );

  constructor(private statementsFacade: StatementsFacade) {}

  onPageChange(page: number): void {
    this.pageChanged.emit(page);
  }

  openPreviewPane(adjustmentUuid: Adjustment['uuid']): void {
    this.adjustmentSelected.emit(adjustmentUuid);
    this.paneOpen();
  }

  closePreviewPane(): void {
    this.adjustmentSelected.emit(null);
    this.paneClose();
  }

  private paneOpen() {
    this.previewPane?.open();
  }

  private paneClose() {
    this.previewPane?.close();
  }
}
